import { GET_FILTERED_HOTSPOT_ERROR, GET_FILTERED_HOTSPOT_POST_ERROR, GET_FILTERED_HOTSPOT_SUCCESS,GET_FILTERED_CSV_HOTSPOT_SUCCESS } from "../actions/types";

export default (state = {
    error: null,
    results: [],
    key:'',
    csv:{}
}, action) => {
    switch (action.type) {
        case GET_FILTERED_HOTSPOT_SUCCESS:
            return {
                ...state,
                results: action.payload,  
                key: action.key,
                loading:false,
                success: true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: "",
            }
            break;
            case GET_FILTERED_CSV_HOTSPOT_SUCCESS:
                return {
                    ...state,
                    csv: action.payload,  
                    loading:false,
                    key: action.key,
                    success: true,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "",
                }
                break;
            case GET_FILTERED_HOTSPOT_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                key: action.key,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: "RETRIEVE ERROR ",
            }
            break;
        case GET_FILTERED_HOTSPOT_POST_ERROR:
            return {
                ...state, 
                error: state.error,
                loading:false,
                key: action.key,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: "RETRIEVE POST ERROR | CONTACT NETWORK ADMINISTRATOR",
            }
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/filteredHotspotReducer.js